import { render, staticRenderFns } from "./PageReference.vue?vue&type=template&id=65090fb6&"
import script from "./PageReference.vue?vue&type=script&lang=js&"
export * from "./PageReference.vue?vue&type=script&lang=js&"
import style0 from "./PageReference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports